import { render, staticRenderFns } from "./AdditionalFeatures.vue?vue&type=template&id=5ee7cb3b&scoped=true"
import script from "./AdditionalFeatures.vue?vue&type=script&lang=js"
export * from "./AdditionalFeatures.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFeatures.vue?vue&type=style&index=0&id=5ee7cb3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7cb3b",
  null
  
)

export default component.exports